import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";

import { HealthService } from "@/services/api/health.service";

@Module({ dynamic: true, store, name: "health" })
export class HealthVuexModule extends VuexModule {
  isSystemInMaintenance = false;

  @Mutation
  setSystemInMaintenance(isSystemInMaintenance: boolean) {
    this.isSystemInMaintenance = isSystemInMaintenance;
  }

  @Action
  public async getSystemStatus() {
    await HealthService.getSystemStatus();
  }

  @Action
  public async changeSystemStatus() {
    if (this.isSystemInMaintenance) return;
    this.setSystemInMaintenance(true);
  }
}

export const HealthModule = getModule(HealthVuexModule);
